import React, { Component } from "react";
import { Panel } from "primereact/panel";
import "primeicons/primeicons.css";
import Server from "./../Server.js";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { confirmAlert } from "react-confirm-alert";
import { connect } from "react-redux";
import { Loader } from "rsuite";
import { InputNumber } from "primereact/inputnumber";
import { Toast } from "primereact/toast";

class Hotels extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();

    this.CreateForm = this.CreateForm.bind(this);
    this.onHideFormsDialog = this.onHideFormsDialog.bind(this);
    this.SetHotels = this.SetHotels.bind(this);
    this.toast = React.createRef();

    this.state = {
      layout: "list",
      numberOfRoom: 0,
      GridDataFields: []
    };
  }
  isMobile(){
    if (window.innerWidth <= 768) {
      this.setState({
        isMobile: true,
      });
    }
  }

  componentDidMount() {
    this.isMobile();

    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        loading: 0,
      });
      that.getManagerSystemInfo();
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack);
  }
  getManagerSystemInfo() {
    let that = this;
    let param = {
      user_id: this.state.user_Id,
    };
    that.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        loading: 0,
        mySystem:
          response.data.result[0] && response.data.result[0].system[0]
            ? response.data.result[0].system[0]
            : { subSystem: false },
      });
      that.getSystems();
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      that.getSystems();
    };
    this.Server.send(
      "MainApi/getManagerSystemInfo",
      param,
      SCallBack,
      ECallBack
    );
  }
  getSystems() {
    let that = this;
    
    let SCallBack = function (response) {
      let systemId = [];
      if (response.data.result) {
        for (let i = 0; i < response.data.result.length; i++) {
          systemId.push({
            value: response.data.result[i]._id,
            name: response.data.result[i].name,
          });
        }
      }
      that.setState({
        systems: systemId,
        managerSystem:
          that.state.mySystem && that.state.mySystem._id
            ? that.state.mySystem._id
            : response.data.result[0]
            ? response.data.result[0]._id
            : null,
      });
      that.getHotels();
    };
    let ECallBack = function (error) {
      that.getHotels();
    };
    this.Server.send("MainApi/getSystems", {}, SCallBack, ECallBack);
  }
  SetHotels() {
    let that = this;

    let param = {
      token: localStorage.getItem("api_token"),
      hotelId: this.state.selectedId,
      params:{
        name: this.state.name,
        number: this.state.number,
        place: this.state.place
      }
      
    };
    
    const rooms = [];
    let index=0;
    let numberOfRoom = 0;
    for(let i=0;i<this.state.numberOfRoom;i++){
      if(this.state["number_"+i]){
        rooms[index] = {
          "number": this.state["number_"+i],
          "numberOfBed": this.state["numberOfBed_"+i],
          "desc": this.state["desc_"+i],
          "deactive": this.state["deactive_"+i]
        }
        index++;
        numberOfRoom++;
      }
    }
    param.rooms = rooms;
    param.params["numberOfRoom"] = numberOfRoom;
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        loading: 0,

      });
      that.getHotels();
      that.toast.current.show({severity:'success', summary: '', detail:"عملیات با موفقیت انجام شد", life: 3000});
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
      that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 5000});
    };
    this.Server.send("CompanyApi/setHotels", param, SCallBack, ECallBack);
  }
  CreateForm() {
    let rooms ={};
    for(let i=0;i<this.state.numberOfRoom;i++){
        rooms["number_"+i] = "";
        rooms["numberOfBed_"+i] = 0;
        rooms["desc_"+i] = "";
    }
    this.setState({
      visibleManageField: true,
      selectedId: null,
      name: "",
      place: "",
      numberOfRoom:0,
      ...rooms
    });
  }
  onHideFormsDialog(event) {
    this.setState({
      visibleManageField: false,
      selectedId: null,
    });
  }
  selectedComponentChange(value) {
    let rooms ={};
    
    if(value.rooms){
      for(let i=0;i<value.rooms.length;i++){
        rooms["number_"+i] = value.rooms[i].number;
        rooms["numberOfBed_"+i] = value.rooms[i].numberOfBed;
        rooms["desc_"+i] = value.rooms[i].desc;
        rooms["deactive_"+i] = value.rooms[i].deactive||false;

        
    }
    }
    
    
    this.setState({
      name: value.name,
      place: value.place,
      desc: value.desc,
      numberOfRoom: value.numberOfRoom,
      system: value.system,
      selectedId: value._id,
      visibleManageField: true,
      ...rooms
    });
  }
  getHotels() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      
      that.setState({
        GridDataFields: response.data.result,
      });
      that.setState({
        loading: 0,
      });
      that.onHideFormsDialog();
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("CompanyApi/getHotels", param, SCallBack, ECallBack);
  }
  delField(rowData) {
    this.setState({
      visibleManageField: false,
    });
    confirmAlert({
      title: <span className="yekan">حذف کاربر</span>,
      message: (
        <span className="yekan"> آیا از حذف {rowData.name} مطمئنید </span>
      ),
      buttons: [
        {
          label: <span className="yekan">بله </span>,
          onClick: () => {
            let that = this;
            let param = {
              token: localStorage.getItem("api_token"),
              _id: rowData._id,
              system: that.state.system,
              del: 1,
            };
            let SCallBack = function (response) {
              that.setState({
                loading: 0,
              });
              that.getHotels();
              that.toast.current.show({severity:'success', summary: '', detail:"عملیات با موفقیت انجام شد", life: 3000});
            };
            let ECallBack = function (error) {
              that.setState({
                loading: 0,
              });
              that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 5000});
            };
            this.Server.send(
              "CompanyApi/SetTravelGroups",
              param,
              SCallBack,
              ECallBack
            );
          },
        },
        {
          label: <span className="yekan">خیر </span>,
        },
      ],
    });
  }
  itemTemplate(brand) {
    return (
      <div
        className="p-clearfix"
        style={{ direction: "rtl", maxWidth: "100%" }}
      >
        <div
          style={{ margin: "10px 10px 0 0" }}
          className="row"
          username={brand.username}
        >
          <div
            className="col-8"
            username={brand.username}
            style={{ textAlign: "right" }}
          >
            <span
              className="iranyekanwebregular"
              style={{ textAlign: "right", overflow: "hidden" }}
              username={brand.username}
            >
              <span
                style={{ whiteSpace: "pre-wrap" }}
                username={brand.username}
              >
                {brand.name}
              </span>
              <br />
            </span>
          </div>
        </div>
      </div>
    );
  }
  render() {
    const footer = (
      <div>
        <button
          className="btn btn-primary irsans"
          onClick={this.SetHotels}
          style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}
        >
          اعمال
        </button>
      </div>
    );

    const statusTemplate = (rowData, props) => {
      if (rowData.enable) {
        return <span>فعال</span>;
      } else {
        return <span>غیر فعال</span>;
      }
    };
    return (
      <div style={{ direction: "rtl" }}>
        <Toast
          ref={this.toast}
          position="top-left"
          style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
        />
        {this.state.loading == 1 && (
          <div
            style={{
              position: "fixed",
              zIndex: 2000,
              top: 10,
              left: 15,
              backgroundColor: "#e89f31",
              padding: "2px 20px",
            }}
          >
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        )}
        <div className="row justify-content-center mt-2">
          <div className="col-12" style={{ background: "#fff" }}>
            <Panel
              header="لیست هتل ها"
              style={{ textAlign: "right", fontFamily: "yekan" }}
            >
              <div className="row">
                <div className="col-6" style={{ textAlign: "right" }}>
                  <button
                    className="btn btn-primary irsans"
                    onClick={this.CreateForm}
                    style={{
                      width: "200px",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    ساخت ردیف جدید
                  </button>
                </div>
              </div>
              <DataTable
                responsive
                value={this.state.GridDataFields}
                selectionMode="single"
                selection={this.state.selectedComponent}
                onSelectionChange={(e) => this.selectedComponentChange(e.value)}
              >
                <Column
                  field="name"
                  header="نام هتل"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="place"
                  header="محل هتل"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="numberOfRoom"
                  header="تعداد اتاق"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
              </DataTable>
            </Panel>
          </div>
        </div>

        <Dialog
          header={this.state.selectedId ? "اصلاح" : "ساخت ردیف جدید"}
          visible={this.state.visibleManageField}
          footer={footer}
          minY={70}
          onHide={this.onHideFormsDialog}
          maximizable={false}
          maximized={true}
        >
          <div className="row  mb-5" style={{ alignItems: "baseline" }}>
            <div className="col-lg-3 mt-3">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    value={this.state.name}
                    name="name"
                    onChange={(event) =>
                      this.setState({ name: event.target.value })
                    }
                    required="true"
                  />
                  <label>نام هتل</label>
                </div>
              </div>
              <div className="col-lg-3 mt-3">
                <div className="group">
                  <input
                    className="form-control irsans"
                    autoComplete="off"
                    type="text"
                    value={this.state.place}
                    name="place"
                    onChange={(event) =>
                      this.setState({ place: event.target.value })
                    }
                    required="true"
                  />
                  <label>مکان هتل</label>
                </div>
              </div>
              <div className="col-lg-3 mt-3">
              <div
                  className="group"  
                  style={{
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <label>تعداد اتاق</label>

                  <InputNumber
                    value={this.state.numberOfRoom}
                    inputStyle={{
                      borderRadius: 0,
                      padding: 0,
                      textAlign: "center",
                      fontSize: 20,
                    }}
                    mode="decimal"
                    showButtons
                    onValueChange={(e) => {
                      this.setState({
                        numberOfRoom: e.value,
                      });
                    }}
                    min={1}
                    max={1000}
                  />
                </div>
              </div>
          </div>
          <div className="row" style={{ alignItems: "baseline",display:this.state.isMobile ? "none" : "flex"  }}>
                    <div className="col-lg-3 col-12" style={{textAlign:'right'}}>
                        <span>شماره اتاق</span>
                    </div>
                    <div className="col-lg-3 col-12" style={{textAlign:'right'}}>
                        <span>تعداد تخت</span>
                    </div>
                    <div className="col-lg-3 col-12" style={{textAlign:'right'}}>
                        <span>توضیح</span>
                    </div>

          </div>
          {Array.from(Array(parseInt(this.state.numberOfRoom)).keys()).map((item, index) => {
              return(
                <div className="row" style={{ alignItems: "baseline" }}>
                    <div className="col-lg-3 col-12">
                            <input
                            className="form-control irsans"
                            placeholder={this.state.isMobile ? "شماره اتاق" : ""}
                            autoComplete="off"
                            type="text"
                            value={this.state["number_" + index]}
                            name={"number_" + index}
                            onChange={(event) =>
                                this.setState({ ["number_" + index]: event.target.value })
                            }
                            required="true"
                        />
                    </div>
                    <div className="col-lg-3 col-12" style={{textAlign:'right'}}>
                    <InputNumber
                    style={{width:"100%",direction:'ltr'}}
                    value={this.state["numberOfBed_" + index]}
                    placeholder={this.state.isMobile ? "شماره اتاق" : ""}
                    inputStyle={{
                      borderRadius: 0,
                      padding: 0,
                      textAlign: "center",
                      fontSize: 20,
                    }}
                    mode="decimal"
                    showButtons
                    onValueChange={(e) => {
                       this.setState({ ["numberOfBed_" + index]: e.value })
                    }}
                    min={1}
                    max={1000}
                  />
                    </div>
                    <div className="col-lg-3 col-12">
                    <input
                            className="form-control irsans"
                            placeholder={this.state.isMobile ? "توضیح" : ""}
                            autoComplete="off"
                            type="text"
                            value={this.state["desc_" + index]}
                            name={"desc_" + index}
                            onChange={(event) =>
                            this.setState({ ["desc_" + index]: event.target.value })
                            }
                            required="true"
                      />
                    </div>
                    
                <div className="col-lg-3">
                <div className="group">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                      inputId={"deactive_" + index}
                      value={this.state["deactive_" + index]}
                      checked={this.state["deactive_" + index]}
                      onChange={(e) => {
                        this.setState({ ["deactive_" + index]: e.checked })
                      }}
                    >
                    </Checkbox>
                    <label
                      htmlFor="active"
                      className="p-checkbox-label yekan"
                      style={{ paddingRight: 5, marginBottom: 0 }}
                    >
                       غیر فعال
                    </label>
                  </div>
                </div>
              </div>

                </div>
              )
          
          })}
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(Hotels);
